
export default function titleize(str) {
  const result = str.replace(/([A-Z])/g, ' $1');
  return `${result.charAt(0).toUpperCase()}${result.slice(1)}`;
}



/** WEBPACK FOOTER **
 ** ./src/utils/titleize.js
 **/